import { render } from "./OrganigrammeDiagram.vue?vue&type=template&id=199e586b"
import script from "./OrganigrammeDiagram.vue?vue&type=script&lang=js"
export * from "./OrganigrammeDiagram.vue?vue&type=script&lang=js"

import "./OrganigrammeDiagram.vue?vue&type=style&index=0&id=199e586b&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__